import { render, staticRenderFns } from "./RideWithConfidence.vue?vue&type=template&id=927fdaa6&scoped=true"
import script from "./RideWithConfidence.vue?vue&type=script&lang=js"
export * from "./RideWithConfidence.vue?vue&type=script&lang=js"
import style0 from "./RideWithConfidence.vue?vue&type=style&index=0&id=927fdaa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927fdaa6",
  null
  
)

export default component.exports